document.documentElement.classList.remove('no-js');

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const product = select.closest('[data-product]');
  const option = select.options[select.selectedIndex];
  const hidden = product?.querySelector('[data-quote-variant]');
  if (hidden) hidden.value = option.textContent.trim();
});

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-menu-toggle]');
  if (!button) return;
  const navigation = document.querySelector('[data-mobile-nav]');
  const expanded = button.getAttribute('aria-expanded') === 'true';
  button.setAttribute('aria-expanded', String(!expanded));
  navigation?.toggleAttribute('hidden', expanded);
});
